import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
const libraries = ["places"];

const GoogleMapsContext = createContext({ isLoaded: false });

export function useGoogleMapsReady() {
  return useContext(GoogleMapsContext).isLoaded;
}

/**
 * Loads Google Maps in the background without blocking modal children.
 * Autocomplete fields activate once `isLoaded` is true.
 */
export default function GoogleMapsProvider({ children }) {
  const { isLoaded } = useJsApiLoader({
    id: "rs-google-maps",
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries,
    preventGoogleFontsLoading: true,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}
